<template>
  <div class="container" v-if="!restrictionState">
    <div 
      v-if="!position"
      @click="getCurrentLocation()" 
      class="btn btn-secondary" 
      id="current-location"
    >
      <div class="flex flex-row">
        <div class="pr-2">
          <svg fill="#000000" width="20px" height="20px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M25.497 6.503l.001-.003-.004.005L3.5 15.901l11.112 1.489 1.487 11.11 9.396-21.992.005-.006z"/></svg>
        </div>

        <div>{{ t('forms.common.current_location_label') }}</div>
      </div>
    </div>

    <div v-if="position" class="flex flex-row">
      <div class="">
        <svg class="h-7 w-7" version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
          <g>
            <path fill="#F76D57" d="M32,52.789l-12-18C18.5,32,16,28.031,16,24c0-8.836,7.164-16,16-16s16,7.164,16,16   c0,4.031-2.055,8-4,10.789L32,52.789z"/>
            <g>
              <path fill="#394240" d="M32,0C18.746,0,8,10.746,8,24c0,5.219,1.711,10.008,4.555,13.93c0.051,0.094,0.059,0.199,0.117,0.289    l16,24C29.414,63.332,30.664,64,32,64s2.586-0.668,3.328-1.781l16-24c0.059-0.09,0.066-0.195,0.117-0.289    C54.289,34.008,56,29.219,56,24C56,10.746,45.254,0,32,0z M44,34.789l-12,18l-12-18C18.5,32,16,28.031,16,24    c0-8.836,7.164-16,16-16s16,7.164,16,16C48,28.031,45.945,32,44,34.789z"/>
              <circle fill="#394240" cx="32" cy="24" r="8"/>
            </g>
          </g>
        </svg>
      </div>


      <div class="flex flex-row">
        <div class="pl-1 cursor-pointer" @click="handleEdit">
          <svg class="h-5 w-5 inline-block" fill="currentColor" viewBox="0 0 20 20"><path d="M17.41,2.59a2,2,0,0,0-2.82,0L7,10.17V13H9.83l7.58-7.59A2,2,0,0,0,17.41,2.59Z"/><path d="M2,6A2,2,0,0,1,4,4H8A1,1,0,0,1,8,6H4V16H14V12a1,1,0,0,1,2,0v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2Z"/></svg>
        </div>

        <a class="pl-1 cursor-pointer text-gray-200 hover:text-red-500" @click="handleDelete">
          <svg class="h-6 w-6 inline-block" fill="currentColor" viewBox="0 0 72 72"><path d="M36.22,4.89A31.23,31.23,0,1,0,67.45,36.12,31.23,31.23,0,0,0,36.22,4.89ZM51.5,45.55a4.12,4.12,0,0,1,0,5.86,4,4,0,0,1-2.92,1.21,4.12,4.12,0,0,1-2.94-1.21L36.22,42l-9.43,9.42a4.15,4.15,0,0,1-5.86,0,4.14,4.14,0,0,1,0-5.86l9.43-9.42L20.93,26.7a4.15,4.15,0,0,1,5.86-5.87l9.43,9.43,9.42-9.43A4.15,4.15,0,0,1,51.5,26.7l-9.42,9.43Z"/></svg>
        </a>
      </div>
    </div>

    <div 
      v-if="!position"
      @click="openModal()" 
      class="btn btn-secondary" 
      style="display: inline-block; margin-left: 1rem;" 
      id="modal-button"
    >
      {{ t('forms.common.pick_point_label') }}
    </div>
  </div>
  <div v-else>
    <div class="text-gray-500">
      {{ t('forms.common.restricted_location_label') }}
    </div>
  </div>
</template>

<script setup>
import ModalService from '@services/ModalService'
import GlobalEventBus from '../services/GlobalEventBus'
import { onMounted, ref, computed, watch } from 'vue'
import i18n from '@utils/i18n'

const { t } = i18n.global

const props = defineProps({
  pointData: Object,
  apiKey: String,
  isRestricted: {
    type: Boolean,
    default: undefined,
  },
})

let lng = ref('')
let lat = ref('')
let position = ref('')
let locationInput = ref('location-input')
let isRestricted = ref(false)

watch(() => props.pointData, (newVal) => {
  if (newVal?.latitude && newVal?.longitude) {
    setLocation(newVal.latitude, newVal.longitude)
  } else {
    lng.value = null
    lat.value = null
    position.value = null
  }
}, { immediate: true }) // immediate: true means it will run when component is mounted

const handleCoordinates = (pos) => {
  console.log("Coordinates received:", pos)
  setLocation(pos.lat, pos.lng)
}

const handlePaulChange = (e) => {
  console.log("Paul Change Event Received", e)

  // If a paul change comes in, lets clear all fields since we could have a location coming in off the TC
  lng.value = null
  lat.value = null
  position.value = null

  // Set location if entity has a location
  if (e.latitude && e.longitude) {
    setLocation(e.latitude, e.longitude)
  }
}

const handleChurchChange = (e) => {
  console.log("Church Change Event Received", e)

  // If a church change comes in, lets clear all fields since we could have a location coming in off the Church
  lng.value = null
  lat.value = null
  position.value = null

  console.log("THE E", e)

  // Set location if entity has a location
  if (e.latitude && e.longitude) {
    setLocation(e.latitude, e.longitude)
  }
}


onMounted(() => {
  GlobalEventBus.subscribe('coordinates', handleCoordinates)
  GlobalEventBus.subscribe('paul-change', handlePaulChange)
  GlobalEventBus.subscribe('church-change', handleChurchChange)

  // Only subscribe to restriction events if no isRestricted prop is provided
  if (props.isRestricted === undefined) {
    GlobalEventBus.subscribe('determine-restriction', restricted => {
      isRestricted.value = restricted
    })
  }

  // When we have an existing location coming off props, lets set it
  if (props.pointData && props.pointData.latitude && props.pointData.longitude) {
    lat.value = props.pointData.latitude
    lng.value = props.pointData.longitude
    position.value = `${props.pointData.latitude}, ${props.pointData.longitude}`
  }
})

const currentPoint = computed(() => {
  if (lat.value && lng.value) {
    return {
      entity: { 
        location_lat: lat.value, 
        location_long: lng.value 
      }
    }
  }

  return props.pointData || null
})

const restrictionState = computed(() => {
  // If isRestricted prop is provided, use it, otherwise use internal state
  const result = props.isRestricted !== undefined ? props.isRestricted : isRestricted.value
  return result
})

function getCurrentLocation(targetEl) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(position => {
      let result = confirm(t('forms.common.confirm_location_label'))

      if (result) {
        GlobalEventBus.dispatch('coordinates', {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        })
      }
    })
  } 
  else {
    position.value = t('forms.common.geolocation_not_supported')
  } 
}

function openModal(opts) {
  ModalService.spawn('google-maps-modal', { pointData: currentPoint.value })
}

function setLocation(latitude, longitude) {
  lat.value = latitude
  lng.value = longitude
  position.value = `${latitude}, ${longitude}`
  setHiddenElements(latitude, longitude)
}

function handleEdit() {
  let locationData = { entity: { lat: lat.value, lng: lng.value } }
  ModalService.spawn('google-maps-modal', { pointData: locationData })
}

function handleDelete() {
  lng.value = null
  lat.value = null
  position.value = null
}

function setHiddenElements(lat, lng) {
  const elements = {
    'hidden-latitude': lat,
    'hidden-longitude': lng
  }

  Object.entries(elements).forEach(([id, value]) => {
    const element = document.getElementById(id)
    if (element) element.value = value
  })
}
</script>

<style scoped>
  .container {
    display: flex;
    flex-direction: row;
  }
</style>